import styles from "./DbManager.module.css";

export type SlotStatus = "active" | "available" | "partial" | "running" | "failed" | "empty";

type StatusBadgeProps = {
  status: SlotStatus;
};

const STATUS_LABELS: Record<SlotStatus, string> = {
  active: "Active",
  available: "Available",
  partial: "Partial",
  running: "Running",
  failed: "Failed",
  empty: "Empty",
};

const STATUS_CLASSES: Record<SlotStatus, string> = {
  active: styles.statusActive,
  available: styles.statusAvailable,
  partial: styles.statusPartial,
  running: styles.statusRunning,
  failed: styles.statusFailed,
  empty: styles.statusEmpty,
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span className={`${styles.statusBadge} ${STATUS_CLASSES[status]}`}>
      {STATUS_LABELS[status]}
    </span>
  );
}
